var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsJurosPosCdi,
                    cor: "#35BAFC",
                    evolucao: _vm.evolucao.estrategia.jurosPosCdi,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsJurosPosCdi.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosCdi.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosCdi.items, function(
                              ativo
                            ) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosCdi.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosCdi.items, function(
                              ativo
                            ) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(" " + _vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsJurosPosInflacao,
                    cor: "#2679ED",
                    evolucao: _vm.evolucao.estrategia.jurosPosInflacao,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsJurosPosInflacao.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosInflacao.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosInflacao.items, function(
                              ativo
                            ) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosInflacao.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPosInflacao.items, function(
                              ativo
                            ) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsJurosPre,
                    cor: "#29BD1A",
                    evolucao: _vm.evolucao.estrategia.jurosPre,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsJurosPre.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPre.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPre.items, function(ativo) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPre.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  monthLabel: _vm.monthLabel,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsJurosPre.items, function(ativo) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(" " + _vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsLivre,
                    cor: "#FAA90F",
                    evolucao: _vm.evolucao.estrategia.livre,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsLivre.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsLivre.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsLivre.items, function(ativo) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsLivre.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsLivre.items, function(ativo) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsRendaVariavel,
                    cor: "#FA5807",
                    evolucao: _vm.evolucao.estrategia.rendaVariavel,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsRendaVariavel.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsRendaVariavel.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsRendaVariavel.items, function(
                              ativo
                            ) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsRendaVariavel.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsRendaVariavel.items, function(
                              ativo
                            ) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsCambio,
                    cor: "#C520FF",
                    evolucao: _vm.evolucao.estrategia.cambio,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsCambio.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para esta estratégia "
                      )
                    ])
                  : _vm._e(),
                !_vm.switchVisualizacao
                  ? _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCambio.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCambio.items, function(ativo) {
                              return _c(
                                "div",
                                {
                                  key: ativo.title,
                                  staticClass: "row-expansion",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c("Body", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showItem(ativo),
                                        expression: "showItem(ativo)"
                                      }
                                    ],
                                    attrs: {
                                      switchView: _vm.switchVisualizacao,
                                      ativo: ativo,
                                      bound: _vm.bound
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCambio.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.telaMobile
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCambio.items, function(ativo) {
                              return _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  staticClass:
                                    "row-expansion switchedVisualizacao",
                                  on: {
                                    click: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "2", xs: "12" }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(ativo.title))
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: {
                                        sm: "12",
                                        md: "1",
                                        xs: "12",
                                        title: ativo.value
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "descricao" }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  ativo.value
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "coluna",
                                      attrs: { sm: "12", md: "9", xs: "12" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "colunas" },
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "row-expansion-2" },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.mesAtual * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.mesAtual
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent1 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor1
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor1
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.dozeMeses * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.dozeMeses
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent2 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.percentageHelper.formatPercentage(
                                                                ativo.percent2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor2
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bound
                                                            ? "---"
                                                            : _vm.currencyHelper.formatValue(
                                                                ativo.valor2
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title:
                                                      ativo.desdeInicio * 100
                                                  }
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.desdeInicio
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "1",
                                                    xs: "12",
                                                    title: ativo.percent3 * 100
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.percentageHelper.formatPercentage(
                                                            ativo.percent3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "coluna-2",
                                                  attrs: {
                                                    sm: "12",
                                                    md: "2",
                                                    xs: "12",
                                                    title: ativo.valor3
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currencyHelper.formatValue(
                                                            ativo.valor3
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }